import { enterpriseApiSlice } from "./index";
import { RolesList } from "../Model/userObjects";

export const rolesApi = enterpriseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchRoles: builder.query({
      query: () => ({
        url: "/roles",
        method: "GET",
      }),
      extraOptions: { auth: true },
      providesTags: ["Roles"],
      transformResponse: (response) => new RolesList(response),
    }),
    createRole: builder.mutation({
      query: (body) => ({
        url: "/roles",
        method: "POST",
        body,
      }),
      extraOptions: { auth: true },
      invalidatesTags: ["Roles"],
    }),
    updateRole: builder.mutation({
      query: ({ roleId, ...body }) => ({
        url: `/roles/${roleId}`,
        method: "PUT",
        body,
      }),
      extraOptions: { auth: true },
      invalidatesTags: ["Roles"],
    }),
    deleteRole: builder.mutation({
      query: (roleId) => ({
        url: `/roles/${roleId}`,
        method: "DELETE",
      }),
      extraOptions: { auth: true },
      invalidatesTags: ["Roles"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useFetchRolesQuery,
  useCreateRoleMutation,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
} = rolesApi;
